import { twMerge } from "tailwind-merge";
import { MessageCircle } from "lucide-react";
import { Button } from "@shared/ui/Button";
import { CountBadge } from "@shared/ui/CountBadge";
import { useChatActions } from "../../hooks/useChat";

export type Props = {
  children?: React.ReactNode;
  variant?: "primary" | "secondary" | "ghost" | "link-inline";
  title?: string;
  unreadCount?: number;
  className?: string;
  containerClassName?: string;
};

export function ChatButton({
  variant = "ghost",
  title = "Open Circle Chat",
  unreadCount = 0,
  children,
  className,
  containerClassName,
}: Props) {
  const { openChat } = useChatActions();

  return (
    <div className={twMerge("relative flex items-center", containerClassName)}>
      <Button
        variant={variant}
        iconComponent={MessageCircle}
        onClick={openChat}
        title={title}
        className={className}
      >
        {children}
      </Button>
      <CountBadge count={unreadCount} />
    </div>
  );
}

export default ChatButton;
